import styled from 'styled-components';
import { ISpinnerWrapperProps } from './Spinner.types';

export const SpinnerWrapper = styled.div<ISpinnerWrapperProps>`  
  &,
  &:after {
    border-radius: 50%;
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
  }
  
  & {
    position: relative;
    text-indent: -9999em;
    border-top: 2px solid ${({ theme }) => theme.spinnerBackgroundColor};
    border-right: 2px solid ${({ theme }) => theme.spinnerBackgroundColor};
    border-bottom: 2px solid ${({ theme }) => theme.spinnerBackgroundColor};
    border-left: 2px solid ${({ theme }) => theme.spinnerSpinColor};
    transform: translateZ(0);
    animation: load8 1.1s infinite linear;
  }
  
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
`;
